/* eslint-disable react-hooks/rules-of-hooks */
import useHomeStore from "./useHomeStore";
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { getMenu } from "../../../services/HomeServices";
import useUsuario from "~/fetchs/useUsuario";
import useParametros from "~/fetchs/useParametros";

export const useHome = () => {
  const { data, setField, clearField, clearAllFields } = useHomeStore();
  return {
    data,
    setField,
    clearField,
    clearAllFields,
  };
};

export const useGetMenu = () => {
  const { usuario } = useUsuario();
  const { getSlug } = useParametros();
  const lojaVirtualUrl = getSlug('link-loja-virtual');

  const menus = useMemo(
    () => getMenu(usuario, { lojaVirtualUrl: lojaVirtualUrl || undefined }),
    [usuario?.ativo, usuario?.slugAcessos, lojaVirtualUrl]
  );

  return menus;
};
